import { Pipe, PipeTransform } from '@angular/core';
import { IDeviceBaseInfo } from '@shared/interfaces/device/device-base-info';

@Pipe({
  name: 'serialNumberWithDeviceType'
})
export class SerialNumberWithDeviceTypePipe implements PipeTransform {

  transform(device: IDeviceBaseInfo): string {
    if (!device) return '';

    return `${device.serialNumber}${device.name !== device.type ? `, Roboze ${device.type}` : ''}`;
  }

}
